<template>
  <YdDialog :visible="visible" append-to-body @close="close" width="60%">
    <div class="title-box">基础数据</div>
    <el-form :model="statisticsForm" size="mini">
      <el-form-item label="时间筛选">
        <el-date-picker
          v-model="statisticsDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-button
          class="margin-left-15"
          type="primary"
          icon="el-icon-search"
          size="mini"
          :disabled="loading"
          @click="getSearchStatistics"
          >筛选</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          :disabled="loading"
          @click="reset('statistics')"
          >清空</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="statisticsList" border size="mini" max-height="280px" style="margin: 0 10px">
      <el-table-column label="活动PV" align="center" prop="viewAllCount" />
      <el-table-column label="活动UV" align="center" prop="viewAllUserCount" />
      <el-table-column label="活动总抽奖次数" align="center" prop="raffleAllCount" />
      <el-table-column label="活动抽奖人数" align="center" prop="raffleAllUserCount" />
    </el-table>
    <div class="title-box margin-top-20">用户参与记录</div>
    <el-form :model="recordForm" size="mini" :inline="true">
      <el-form-item label="时间筛选">
        <el-date-picker
          style="width: 300px"
          v-model="recordDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item label="用户搜索">
        <el-input v-model.trim="recordForm.userPhone" placeholder="输入用户手机号" clearable />
      </el-form-item>
      <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        :disabled="loading"
        @click="search"
        >筛选</el-button
      >
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="mini"
        :disabled="loading"
        @click="reset('record')"
        >清空</el-button
      >
    </el-form>
    <yd-table
      :loading="loading"
      :data="recordList"
      border
      size="mini"
      :pagination="pagination"
      @onChange="onTableChange"
      @onInit="onInit"
    >
      <el-table-column label="用户ID" prop="userId" align="center" />
      <el-table-column label="用户手机号" prop="userPhone" align="center" />
      <el-table-column label="抽奖时间" prop="raffleTime" align="center" />
      <el-table-column label="抽奖情况" prop="prizeName" align="center" />
    </yd-table>
    <div slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="exportExcel">导 出</el-button>
    </div>
  </YdDialog>
</template>

<script>
  import { prizeStatistics, userPrizeRecord } from '@/api/marketing/prize-draw'
  import { exportToExcel } from '@/util/exportToExcel'
  export default {
    name: 'prizeStatistics',
    data() {
      return {
        statisticsList: [],
        statisticsForm: {}, // 基础信息表单
        statisticsDate: [], // 基础信息时间
        recordForm: {
          userPhone: ''
        }, // 用户参与记录表单
        recordDate: [], // 用户参与时间
        loading: false,
        recordList: [], // 用户参与记录列表
        // 分页
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        header: {} // 表头
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      activityId: {
        type: String,
        default: ''
      }
    },
    computed: {
      notice() {
        return ''
      }
    },
    mounted() {},
    methods: {
      getSearchStatistics() {
        const prams = {
          activityId: this.activityId,
          endTime: this.statisticsDate.length ? this.statisticsDate[1] + ' 23:59:59' : '',
          startTime: this.statisticsDate.length ? this.statisticsDate[0] + ' 00:00:00' : ''
        }
        prizeStatistics(prams).then((res) => {
          if (res.code) return
          this.statisticsList = [
            {
              raffleAllCount: res.data.raffleAllCount,
              raffleAllUserCount: res.data.raffleAllUserCount,
              viewAllCount: res.data.viewAllCount,
              viewAllUserCount: res.data.viewAllUserCount
            }
          ]
        })
      },
      getUserPrizeRecord() {
        const prams = {
          ...this.pagination,
          activityId: this.activityId,
          endTime: this.recordDate.length ? this.recordDate[1] + ' 23:59:59' : '',
          startTime: this.recordDate.length ? this.recordDate[0] + ' 00:00:00' : '',
          userPhone: this.recordForm.userPhone,
          size: this.pagination.pageSize
        }
        userPrizeRecord(prams).then((res) => {
          if (res.code) return
          this.recordList = res.data.records
          this.pagination.total = res.data.total
        })
      },
      close() {
        this.recordForm = {
          userPhone: ''
        }
        this.statisticsDate = []
        this.recordDate = []
        this.$emit('close')
      },
      async init() {
        this.$nextTick(() => {
          this.getSearchStatistics()
          this.getUserPrizeRecord()
        })
      },
      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.pageSize = pageSize
        this.getUserPrizeRecord()
      },
      onInit(obj) {
        obj.columns.value.forEach((it) => {
          this.header[it.prop] = it.label
        })
      },
      async exportExcel() {
        this.$confirm('导出订单需要较长时间，请耐心等待', '确定导出吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.createExcel()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      async createExcel() {
        const notFields = []
        const query = {
          ...this.recordForm,
          page: 1,
          current: 1,
          size: 100,
          activityId: this.activityId,
          endTime: this.recordDate.length ? this.recordDate[1] + ' 23:59:59' : '',
          startTime: this.recordDate.length ? this.recordDate[0] + ' 00:00:00' : ''
        }
        exportToExcel(userPrizeRecord, query, this.header, notFields, {
          custom: true,
          isHeaderSort: true,
          customName: '用户参与记录'
        })
      },
      reset(type) {
        if (type === 'statistics') {
          this.statisticsDate = []
          this.getSearchStatistics()
        } else {
          this.recordForm = {
            userPhone: ''
          }
          this.recordDate = []
          this.pagination = {
            current: 1,
            pageSize: 10,
            total: 0
          }
          this.getUserPrizeRecord()
        }
      },
      search() {
        this.pagination.current = 1
        this.getUserPrizeRecord()
      }
    }
  }
</script>
<style scoped lang="scss">
  .title-box {
    margin: 0 0 20px 10px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
</style>
